<template>
  <v-container fluid class="tiempos-reconocimiento-root">
    <v-card tile>
      <div class="pl-6">
        <p class="text-body-1 font-weight-regular pt-4">
          Tiempos de Evaluación — Canal Web Reconocimiento
        </p>
        <p
          class="text-caption text--secondary font-weight-bold mt-n3 pb-4"
          v-if="selectedFecha && selectedFecha[0]"
        >
          <v-icon color="black">mdi-calendar-range</v-icon>
          del {{ selectedFecha[0] }} al {{ selectedFecha[1] }}
        </p>
      </div>
    </v-card>

    <!-- Selector de rango de fechas -->
    <v-row class="mt-2">
      <v-col cols="12" sm="4" md="3">
        <v-menu
          ref="fechaDialog"
          v-model="modalFechas"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="selectedFechaTexto"
              readonly
              dense
              hide-details
              outlined
              label="Rango de fechas"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="es"
            width="240"
            no-title
            scrollable
            v-model="dialogVarSelectedFecha"
            range
            :max="disabledFecha"
            color="primary"
            header-color="primary"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalFechas = false"
              >Cancelar</v-btn
            >
            <v-btn text color="primary" @click="fnAplicarRango">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="8" md="5">
        <v-text-field
          v-model="busqueda"
          dense
          hide-details
          outlined
          label="Buscar por DPI o nombre"
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>

    <v-alert type="info" outlined dense class="mt-2">
      Las evaluaciones abandonadas antes de completar una etapa se muestran
      con <strong>N/D</strong> en las columnas correspondientes y no afectan
      los promedios de las etapas que sí tienen dato.
    </v-alert>

    <!-- KPIs -->
    <v-row v-if="!cargando" class="mt-2">
      <v-col cols="6" sm="3" md="2">
        <v-card outlined class="pa-3 fill-height">
          <div class="text-caption text--secondary">
            Gestiones en el rango
            <v-tooltip bottom max-width="260">
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-small v-bind="attrs" v-on="on"
                  >mdi-information-outline</v-icon
                >
              </template>
              <span
                >Cantidad de evaluaciones creadas en el rango de fechas
                seleccionado.</span
              >
            </v-tooltip>
          </div>
          <div class="text-h5 font-weight-medium">
            {{ fnFormatNumero(resumen.totalGestiones) }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <v-card outlined class="pa-3 fill-height">
          <div class="text-caption text--secondary">
            Con datos completos
            <v-tooltip bottom max-width="260">
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-small v-bind="attrs" v-on="on"
                  >mdi-information-outline</v-icon
                >
              </template>
              <span
                >Evaluaciones que completaron los 4 pasos, así que se pudo
                medir cuánto tardó cada uno y el tiempo total (excluye
                abandonadas a medio flujo).</span
              >
            </v-tooltip>
          </div>
          <div class="text-h5 font-weight-medium">
            {{ fnFormatNumero(resumen.gestionesConDatosCompletos) }}
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="!cargando">
      <v-col cols="6" sm="4" md="2" v-for="etapa in etapasResumen" :key="etapa.clave">
        <v-card outlined class="pa-3 fill-height">
          <div class="text-caption text--secondary">
            {{ etapa.titulo }}
            <v-tooltip bottom max-width="260">
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-small v-bind="attrs" v-on="on"
                  >mdi-information-outline</v-icon
                >
              </template>
              <span>{{ etapa.descripcion }}</span>
            </v-tooltip>
          </div>
          <div class="text-h5 font-weight-medium">
            {{ fnFormatDuracion(resumen[etapa.clave]) }}
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" class="text-center pa-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>

    <!-- Gráfica de promedio por etapa -->
    <v-row class="mt-2">
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="text-subtitle-2 mb-2">
            Promedio de duración por etapa (minutos)
          </div>
          <canvas ref="canvasPromedios" height="220"></canvas>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabla por gestión -->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="text-subtitle-1"
            >Detalle por gestión (periodo seleccionado)</v-card-title
          >
          <v-data-table
            dense
            :headers="headers"
            :items="filasFiltradas"
            :custom-sort="fnCustomSort"
            :loading="cargando"
            class="elevation-1"
          >
            <template v-slot:[`header.duracion_step1_seg`]="{ header }">
              {{ header.text }}
              <v-tooltip bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >Tiempo que tardó en el Step 1: ingresar datos de
                  contacto.</span
                >
              </v-tooltip>
            </template>
            <template v-slot:[`header.duracion_step2_seg`]="{ header }">
              {{ header.text }}
              <v-tooltip bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >Tiempo que tardó en verificar su identidad con el código
                  (OTP) enviado por SMS o correo.</span
                >
              </v-tooltip>
            </template>
            <template v-slot:[`header.duracion_step3_seg`]="{ header }">
              {{ header.text }}
              <v-tooltip bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >Tiempo que tardó en registrar su domicilio y subir fotos
                  de fachada y recibo de servicios.</span
                >
              </v-tooltip>
            </template>
            <template v-slot:[`header.duracion_step4_seg`]="{ header }">
              {{ header.text }}
              <v-tooltip bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >Tiempo que tardó en el último paso: foto de
                  identificación, verificación facial y firma.</span
                >
              </v-tooltip>
            </template>
            <template v-slot:[`header.duracion_total_seg`]="{ header }">
              {{ header.text }}
              <v-tooltip bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >Tiempo total desde que la persona empieza la evaluación
                  hasta que la termina por completo.</span
                >
              </v-tooltip>
            </template>
            <template v-slot:[`header.completo`]="{ header }">
              {{ header.text }}
              <v-tooltip bottom max-width="260">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >"Completa": terminó los 4 pasos y se pudo medir el tiempo
                  total. "Incompleta": se quedó a medio camino (aún no
                  termina o abandonó el proceso).</span
                >
              </v-tooltip>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <router-link :to="`/detalle-reconocimiento-facial/${item.id}`">
                {{ item.id }}
              </router-link>
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ fnFormatFecha(item.createdAt) }}
            </template>
            <template v-slot:[`item.duracion_step1_seg`]="{ item }">
              {{ fnFormatDuracion(item.duracion_step1_seg) }}
            </template>
            <template v-slot:[`item.duracion_step2_seg`]="{ item }">
              {{ fnFormatDuracion(item.duracion_step2_seg) }}
            </template>
            <template v-slot:[`item.duracion_step3_seg`]="{ item }">
              {{ fnFormatDuracion(item.duracion_step3_seg) }}
            </template>
            <template v-slot:[`item.duracion_step4_seg`]="{ item }">
              {{ fnFormatDuracion(item.duracion_step4_seg) }}
            </template>
            <template v-slot:[`item.duracion_total_seg`]="{ item }">
              {{ fnFormatDuracion(item.duracion_total_seg) }}
            </template>
            <template v-slot:[`item.completo`]="{ item }">
              <v-chip x-small :color="item.completo ? 'green' : 'grey'" dark>
                {{ item.completo ? 'completa' : 'incompleta' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
require('moment/locale/es.js');
import axios from 'axios';
import {
  Chart,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

Chart.register(BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend);

// Paleta validada (skill dataviz — references/palette.md), sin modo oscuro: este panel no tiene tema oscuro.
const COLOR_BARRA = '#2a78d6';
const COLOR_MUTED = '#898781';
const COLOR_GRID = '#e1e0d9';

const ETAPAS_RESUMEN = [
  {
    clave: 'promedioStep1Seg',
    titulo: 'Promedio Step1 (datos de contacto)',
    descripcion:
      'Tiempo promedio que tardan los usuarios en completar el primer paso: ingresar sus datos de contacto (teléfono y correo).',
  },
  {
    clave: 'promedioStep2Seg',
    titulo: 'Promedio Step2 (verificación OTP)',
    descripcion:
      'Tiempo promedio en verificar su identidad con el código (OTP) enviado por SMS o correo.',
  },
  {
    clave: 'promedioStep3Seg',
    titulo: 'Promedio Step3 (domicilio/fotos)',
    descripcion:
      'Tiempo promedio en registrar su domicilio y subir fotos de fachada y recibo de servicios.',
  },
  {
    clave: 'promedioStep4Seg',
    titulo: 'Promedio Step4 (identidad/firma)',
    descripcion:
      'Tiempo promedio en el último paso: foto de identificación, verificación facial (selfie) y firma.',
  },
  {
    clave: 'promedioTotalSeg',
    titulo: 'Promedio TOTAL',
    descripcion:
      'Tiempo promedio desde que la persona empieza la evaluación hasta que la termina por completo.',
  },
];

export default {
  name: 'tiemposEvaluacionReconocimiento',
  data() {
    return {
      cargando: true,
      busqueda: '',

      modalFechas: false,
      dialogVarSelectedFecha: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      selectedFecha: [
        moment().startOf('month').format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY'),
      ],
      disabledFecha: moment().format('YYYY-MM-DD'),

      resumen: {
        totalGestiones: 0,
        gestionesConDatosCompletos: 0,
        promedioStep1Seg: null,
        promedioStep2Seg: null,
        promedioStep3Seg: null,
        promedioStep4Seg: null,
        promedioTotalSeg: null,
      },
      filas: [],

      etapasResumen: ETAPAS_RESUMEN,

      headers: [
        { text: 'ID', value: 'id' },
        { text: 'DPI', value: 'dpi' },
        { text: 'Nombre', value: 'deudor_nombre_completo' },
        { text: 'Fecha', value: 'createdAt' },
        { text: 'Step1', value: 'duracion_step1_seg' },
        { text: 'Step2', value: 'duracion_step2_seg' },
        { text: 'Step3', value: 'duracion_step3_seg' },
        { text: 'Step4', value: 'duracion_step4_seg' },
        { text: 'Total', value: 'duracion_total_seg' },
        { text: 'Estado', value: 'completo' },
      ],

      chartPromedios: null,
    };
  },

  computed: {
    feathersServer() {
      return process.env.VUE_APP_FEATHERS_SERVER;
    },
    selectedFechaTexto() {
      return this.selectedFecha && this.selectedFecha[0]
        ? `${this.selectedFecha[0]} — ${this.selectedFecha[1]}`
        : '';
    },
    filasFiltradas() {
      const texto = (this.busqueda || '').trim().toLowerCase();
      if (!texto) return this.filas;
      return this.filas.filter((f) =>
        (f.dpi || '').toLowerCase().includes(texto) ||
        (f.deudor_nombre_completo || '').toLowerCase().includes(texto)
      );
    },
  },

  methods: {
    fnFormatNumero(n) {
      return Number(n || 0).toLocaleString('es-GT');
    },
    fnFormatFecha(fecha) {
      return fecha ? moment(fecha).format('DD-MM-YYYY HH:mm') : 'N/D';
    },
    // seg: number|null (segundos). null → dato ausente (evaluación incompleta o
    // etapa aún no alcanzada) — nunca se muestra como 0 ni como negativo.
    fnFormatDuracion(seg) {
      if (seg === null || seg === undefined) return 'N/D';
      if (seg < 3600) {
        const m = Math.floor(seg / 60);
        const s = Math.round(seg % 60);
        return `${m}m ${s}s`;
      }
      const h = Math.floor(seg / 3600);
      const m = Math.round((seg % 3600) / 60);
      return `${h}h ${m}m`;
    },
    fnAuthHeaders() {
      return {
        Authorization: 'Bearer ' + window.localStorage.getItem('feathers-jwt'),
      };
    },

    fnAplicarRango() {
      this.selectedFecha = [
        moment(this.dialogVarSelectedFecha[0]).format('DD-MM-YYYY'),
        moment(this.dialogVarSelectedFecha[1]).format('DD-MM-YYYY'),
      ];
      this.modalFechas = false;
      this.cargarReporte();
    },

    // Mantiene los valores null siempre al final de la tabla, sin importar
    // si el orden es ascendente o descendente — evita que "N/D" se mezcle
    // con duraciones reales en la columna ordenada.
    fnCustomSort(items, sortBy, sortDesc) {
      if (!sortBy.length) return items;
      const campo = sortBy[0];
      const desc = sortDesc[0];
      return [...items].sort((a, b) => {
        const va = a[campo];
        const vb = b[campo];
        if (va === null || va === undefined) return 1;
        if (vb === null || vb === undefined) return -1;
        if (va < vb) return desc ? 1 : -1;
        if (va > vb) return desc ? -1 : 1;
        return 0;
      });
    },

    async cargarReporte() {
      this.cargando = true;
      try {
        const [start, end] = this.dialogVarSelectedFecha;
        const r = await axios.get(
          `${this.feathersServer}reconocimiento-tiempos-evaluacion`,
          {
            params: { start, end },
            headers: this.fnAuthHeaders(),
            timeout: 30000,
          }
        );
        this.resumen = r.data.resumen || this.resumen;
        this.filas = r.data.filas || [];
      } catch (err) {
        console.error('reconocimiento-tiempos-evaluacion: error al cargar reporte', err.message);
        this.resumen = {
          totalGestiones: 0,
          gestionesConDatosCompletos: 0,
          promedioStep1Seg: null,
          promedioStep2Seg: null,
          promedioStep3Seg: null,
          promedioStep4Seg: null,
          promedioTotalSeg: null,
        };
        this.filas = [];
      } finally {
        this.cargando = false;
        this.$nextTick(() => this.renderGraficaPromedios());
      }
    },

    renderGraficaPromedios() {
      if (this.chartPromedios) {
        this.chartPromedios.destroy();
        this.chartPromedios = null;
      }
      const canvas = this.$refs.canvasPromedios;
      if (!canvas) return;

      const enMinutos = (seg) => (seg === null || seg === undefined ? 0 : seg / 60);
      this.chartPromedios = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels: ['Step1', 'Step2', 'Step3', 'Step4'],
          datasets: [
            {
              data: [
                enMinutos(this.resumen.promedioStep1Seg),
                enMinutos(this.resumen.promedioStep2Seg),
                enMinutos(this.resumen.promedioStep3Seg),
                enMinutos(this.resumen.promedioStep4Seg),
              ],
              backgroundColor: COLOR_BARRA,
              borderRadius: 4,
              maxBarThickness: 40,
            },
          ],
        },
        options: {
          plugins: { legend: { display: false } },
          scales: {
            x: { grid: { display: false }, ticks: { color: COLOR_MUTED } },
            y: {
              beginAtZero: true,
              grid: { color: COLOR_GRID, drawBorder: false },
              ticks: { color: COLOR_MUTED },
            },
          },
        },
      });
    },
  },

  mounted() {
    this.cargarReporte();
  },

  beforeDestroy() {
    if (this.chartPromedios) this.chartPromedios.destroy();
  },
};
</script>

<style scoped>
.tiempos-reconocimiento-root {
  --surface-1: #fcfcfb;
  --text-secondary: #52514e;
  --text-muted: #898781;
}
</style>
